import request from '@/utils/request'

// 查询加入我们列表
export function listJoin(query) {
    return request({
        url: '/dy/website/getJoin',
        method: 'get',
        params: query
    })
}

// 查询专业团队列表
export function listTeam(query) {
    return request({
        url: '/dy/website/getTeam',
        method: 'get',
        params: query
    })
}

// 查询专业团队详细
export function getTeam(id) {
    return request({
        url: '/dy/website/getTeamInfo/' + id,
        method: 'get'
    })
}

// 查询业务领域列表
export function listBusiness(query) {
    return request({
        url: '/dy/website/getBusiness',
        method: 'get',
        params: query
    })
}

// 查询业务领域详细
export function getBusiness(id) {
    return request({
        url: '/dy/website/getBusinessInfo/' + id,
        method: 'get'
    })
}

// 查询新闻资讯列表
export function listNews(query) {
    return request({
        url: '/dy/website/getNews',
        method: 'get',
        params: query
    })
}

// 查询新闻资讯详细
export function getNews(id) {
    return request({
        url: '/dy/website/getNewsInfo/' + id,
        method: 'get'
    })
}

// 当前新闻资讯的上一条
export function getPreviousNews(id) {
    return request({
        url: '/dy/website/previousNewsById/' + id,
        method: 'get'
    })
}

// 当前新闻资讯的下一条
export function getNextNews(id) {
    return request({
        url: '/dy/website/nextNewsById/' + id,
        method: 'get'
    })
}

// 查询导航栏目列表
export function listMenu(query) {
    return request({
        url: '/dy/website/getMenu',
        method: 'get',
        params: query
    })
}


// WEBPACK FOOTER //
// ./src/api/web.js